/* React */
import React from "react";

/* React-Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { setWidth } from "src/redux/features/insights-options/treatment-patterns/sankey-diagram/sankeyDiagramOptionsSlice";
import { setMaxDepth } from "src/redux/features/insights-options/treatment-patterns/sankey-diagram/sankeyDiagramOptionsSlice";
import { setShowNoValueStates } from "src/redux/features/insights-options/treatment-patterns/sankey-diagram/sankeyDiagramOptionsSlice";

/* Components */
import SimpleSlider from "src/components/shared/slider/simple-slider/SimpleSlider";
import ShowNoValueEntries from "src/components/insights/insights-options/descriptive-statistics/show-no-value-entries/ShowNoValueEntries";

/* Hooks */
import { useIsCustomCohortActive } from "src/utils/hooks/useIsCustomCohortActive";

/* Stylesheet */
import styles from "./SankeyDiagramOptions.module.scss";

const SankeyDiagramOptions: React.FC = () => {
  const dispatch = useDispatch();

  const sankeyDiagramOptionsState = useSelector(
    (state: RootState) => state.sankeyDiagramOptions
  );

  const { maxDepth, width, minMax, showNoValueStates } =
    sankeyDiagramOptionsState;
  const { min, max } = minMax;

  const isCustomCohortActive = useIsCustomCohortActive();

  const handleTreatmentLines = (value: number) => {
    dispatch(setMaxDepth(value));
  };

  const handleMinAbsoluteWidth = (value: number) => {
    dispatch(setWidth(value));
  };

  return (
    <div className={styles.sankey_diagram_options}>
      <SimpleSlider
        scssProps={{
          margin: "0px 0px 52px 0px",
        }}
        label={"Number of treatment lines"}
        min={2}
        max={10}
        ticks={true}
        snaps={true}
        pin={true}
        value={maxDepth}
        onChange={handleTreatmentLines}
      />
      <SimpleSlider
        label={"Treatment zoom"}
        min={min}
        max={max}
        ticks={false}
        snaps={false}
        pin={true}
        value={width}
        onChange={handleMinAbsoluteWidth}
      />
      <ShowNoValueEntries
        showNoValueEntries={showNoValueStates}
        disabled={isCustomCohortActive}
        handleShowNoValueEntries={() =>
          dispatch(setShowNoValueStates(!showNoValueStates))
        }
      />
    </div>
  );
};

export default SankeyDiagramOptions;
